// extracted by mini-css-extract-plugin
export var divider = "_o9-0";
export var systemMessage = "_o9-1";